import { render } from "./contactUs.vue?vue&type=template&id=b39667c6&scoped=true&ts=true"
import script from "./contactUs.vue?vue&type=script&lang=ts"
export * from "./contactUs.vue?vue&type=script&lang=ts"

import "./contactUs.vue?vue&type=style&index=0&id=b39667c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b39667c6"]])

export default __exports__